<template>
  <div class="glass-nav">
    <div class="container mx-auto">
      <div class="grid grid-cols-3 pt-2">
        <!-- 关于我们 -->
        <div class="flex flex-col pt-3 space-y-1">
          <span class="text-base font-bold">教育理念</span>
          <span class="flex flex-row text-xs font-semibold lg:text-sm">
            <p class="text-red-400">Swift &nbsp;</p>
            <p>编程，</p>
            <p>助力每个人的科创梦想!</p>
          </span>
        </div>
        <div class="flex flex-col items-center space-y-1">
          <span class="text-base font-bold">关于我们</span>
          <Nuxt-link to="https://www.sbs.edu.cn/" target="_blank" rel="noopener noreferrer">
            <a class="flex items-center space-x-1 text-xs font-semibold lg:text-sm hover:text-blue-500">
              <p>上海商学院</p>
              <el-icon>
                <ArrowRight />
              </el-icon>
            </a>
          </Nuxt-link>
          <Nuxt-link to="http://www.qingmaoedu.com" target="_blank" rel="noopener noreferrer">
            <a class="flex items-center space-x-1 text-xs font-semibold lg:text-sm hover:text-blue-500">
              <p>上海晴猫网络科技有限公司</p>
              <el-icon>
                <ArrowRight />
              </el-icon>
            </a>
          </Nuxt-link>
        </div>
        <div class="flex flex-col items-end pt-3 space-y-1">
          <span class="text-base font-bold">联系我们</span>
          <div class="flex flex-row items-center space-x-1 text-xs lg:text-sm">
            <el-icon>
              <Message />
            </el-icon>
            <p class="pb-1 font-semibold">contactus@qingmaoedu.com</p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-center w-full opacity-0 hover:opacity-50 max-h-2">
      <span class="font-semibold text-black" style="font-size: 8px">Version:{{ buildDate }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ArrowRight, Message } from '@element-plus/icons-vue'
const buildDate = ref('')

onMounted(() => {
  const { buildDateTime } = useRuntimeConfig().public
  console.log('获取到的时间', buildDateTime)
  buildDate.value = buildDateTime
})
</script>

<style scoped></style>
